import { useTranslate } from '@ur-solutions/react-hooks'
import type { IssueSeverity } from './types.graphl'
import type { TypeChart } from '../activities'

export function useIssueSeverityOptions() {
  const translations = useTranslate({
    severityGrades: {
      LOW: 'common.low',
      MEDIUM: 'common.medium',
      HIGH: 'common.high',
    },
  })
  const severityOptions = [
    { value: 'LOW', label: translations.severityGrades.LOW },
    { value: 'MEDIUM', label: translations.severityGrades.MEDIUM },
    { value: 'HIGH', label: translations.severityGrades.HIGH },
  ] as {
    value: IssueSeverity
    label: string
  }[]

  return severityOptions
}

export function useDateOptions() {
  const translations = useTranslate({
    chart: {
      DAY: 'common.day',
      WEEK: 'common.week',
      MONTH: 'common.month',
    },
  })

  const chartOptions: { label: string; value: TypeChart }[] = [
    { label: translations.chart.DAY, value: 'day' },
    { label: translations.chart.WEEK, value: 'week' },
    { label: translations.chart.MONTH, value: 'month' },
  ]

  return {
    chartOptions,
  }
}
